import * as React from "react";
import { styled } from "@mui/material/styles";
import { Paper, InputBase, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// Styled Input with placeholder styling
const StyledInput = styled(InputBase)(({ theme }) => ({
  "& input::placeholder": {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#000000",
    mixBlendMode: "normal",
    opacity: 0.4,
  },
}));

// Styled Paper
const SearchPaper = styled(Paper)(({ theme }) => ({
  padding: "15px 18px",
  display: "flex",
  alignItems: "center",
  width: "inherit",
  height: "50px",
  borderRadius: "30px",
  justifyContent: "space-between",
  boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
}));

export default function Search({ setPage, handleSearchDebounce }) {
  return (
    <SearchPaper component="form" elevation={0}>
      <StyledInput
        fullWidth
        placeholder="Search"
        onChange={(e) => {
          setPage(1);
          handleSearchDebounce(e.target.value);
        }}
        sx={{
          "&::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#000000",
            mixBlendMode: "normal",
            opacity: 0.4,
          },
        }}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon sx={{ color: "rgba(128, 128, 128, 0.7)" }} />
      </IconButton>
    </SearchPaper>
  );
}
